import { Grid } from "@intility/bifrost-react";
import { ManagementAccessSection } from "~/components/management/ManagementAccessSection";
import type { PlatformDetail } from "../../../api/types";

export function PlatformAccess({ platform }: { platform: PlatformDetail }) {
  return (
    <ManagementAccessSection
      // keycloak-api owns the management object id (ADR-0056). The Portal
      // never builds it.
      objectId={platform.managementObjectId}
      objectLabel="platform"
      grantButton="table"
      heading={
        <Grid gap={4}>
          <h2 className="bf-h2" style={{ margin: 0 }}>
            Management
          </h2>
          <p className="bf-large bfc-base-2" style={{ margin: 0 }}>
            Who can manage this platform, and who can grant others access.
          </p>
        </Grid>
      }
    />
  );
}
